import Permissions from '../../models/Permissions'
const Answered = () => import(/* webpackChunkName: "reports" */ './Answered.vue')
const GeneralReport = () => import(/* webpackChunkName: "generalReport" */ './GeneralReport.vue')

const permissions = [
  Permissions.ROOT,
  Permissions.ADMINISTRADOR
]

const report = {
  path: 'reports',
  name: 'Relatório',
  component: Answered,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

const general = {
  path: 'general/report',
  name: 'Relatório Geral',
  component: GeneralReport,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

export default {
  report,
  general
}



// WEBPACK FOOTER //
// ./src/views/answered/index.js